import React, { useState } from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useQuery } from '@apollo/client'
import querystring from 'querystring'
import uuidGenerator from 'uuid/v4'
import Font from '@cred/react-font'
import withApolloProvider from 'components/hocs/withApolloProvider'
import { useViewport } from 'components/hooks'
import Pagination from 'components/styled-pagination'
import CreditCardsFilter from 'credit-card/card-table/shared/filter-form'
import Spinner from 'credit-card/card-table/spinner'
import NoCards from 'credit-card/card-table/no-cards'
import { GET_CARDS_QUERY } from 'credit-card/card-table/api/queries'
import FilterModal from '../components/filter-modal'
import CardTile from './components/card-tile'
import { generateFilterText, generateUpdate, getPageStats, getPartnerDefaultFilterValues } from '../utils'
import styles from './styles.module.scss'

const formName = 'credit-cards-category',
  paginationName = 'credit-cards-table',
  breakpoint = 568,

  initialValues = {
    categoryFilter: 'featured',
  },

  mapStateToProps = (state, ownProps) => ({
    formFilterValues: state.form[formName],
    page: state.components.pagination[paginationName],
    defaultFilterValues: {
      ...initialValues,
      ...getPartnerDefaultFilterValues(ownProps.widgetContext, 'credit-cards'),
    },
  }),

  getTilePerPage = () => {
    const width = useViewport()

    return width >= breakpoint ? 3 : 2
  },

  uuid = uuidGenerator(),

  getCtaUrl = (slug, utms) => {
    if (utms) {
      return `/credit-cards/apply-now/link-card/${slug}?${querystring.encode(utms)}&redirection_uuid=${uuid}`
    }

    return `/credit-cards/apply-now/link-card/${slug}?redirection_uuid=${uuid}`
  },

  getCreditCards = (category) => (
    useQuery(GET_CARDS_QUERY, {
      variables: {
        limit: 3,
        category,
      },
    })
  ),

  CreditCardsRateTable = ({
    formFilterValues,
    variation,
    page,
    utms,
    widgetContext,
    defaultFilterValues,
    omitUtmParams,
  }) => {
    const [filterValues, setFilterValues] = useState(defaultFilterValues),
      { loading, error, data } = getCreditCards(filterValues.categoryFilter),
      cards = data && !error ? data.creditCards : [],
      { pageCount, pageFrom, pageTo, showPagination } = getPageStats(variation, cards, page, getTilePerPage())

    return (
      <div>
        <FilterModal formName={formName} filterText={generateFilterText(filterValues, 'credit-cards')}>
          {({ closeModal }) => (
            <CreditCardsFilter
              form={formName}
              withFooter
              initialValues={filterValues}
              closeModal={closeModal}
              update={generateUpdate(formFilterValues, setFilterValues, closeModal)}
            />
          )}
        </FilterModal>
        { loading ? (
          <Spinner />
        ) : (
          <>
            {cards.length > 0 ? (
              <div className="multivertical-lenders-list">
                <Font className={styles.partnerOffers}>Partner Offers. Terms Apply.</Font>
                {cards.slice(pageFrom, pageTo).map((card, idx) => (
                  <CardTile
                    card={card}
                    idx={idx}
                    key={card.slug}
                    category={filterValues.categoryFilter}
                    ctaUrl={getCtaUrl(card.slug, omitUtmParams ? null : utms)}
                    widgetContext={widgetContext}
                    uuid={uuid}
                  />
                ))}
              </div>
            ) : (
              <NoCards />
            )}
          </>
        )}
        { showPagination && (
          <Pagination
            pageCount={pageCount}
            name={paginationName}
          />
        )}
      </div>
    )
  }

CreditCardsRateTable.propTypes = {
  page: PropTypes.number,
  variation: PropTypes.string,
  formFilterValues: PropTypes.object,
  utms: PropTypes.shape({
    utm_source: PropTypes.string,
    utm_campaign: PropTypes.string,
    utm_medium: PropTypes.string,
    utm_content: PropTypes.string,
    credclid: PropTypes.string,
    renderId: PropTypes.string,
  }),
  widgetContext: PropTypes.object,
  defaultFilterValues: PropTypes.shape({
    categoryFilter: PropTypes.string,
  }),
  omitUtmParams: PropTypes.bool,
}

CreditCardsRateTable.defaultProps = {
  page: 0,
  omitUtmParams: false,
}

export { CreditCardsRateTable, getCreditCards, getCtaUrl, mapStateToProps }

export default compose(
  withApolloProvider,
  connect(mapStateToProps),
)(CreditCardsRateTable)
